import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Star, MessageSquare, Mail, Loader2 } from "lucide-react";

const Stars = ({ n }) => (
  <span className="inline-flex gap-0.5 align-middle">
    {[1, 2, 3, 4, 5].map((i) => (
      <Star key={i} className="w-4 h-4" style={{ color: i <= n ? "#002FA7" : "#D4D4D8", fill: i <= n ? "#002FA7" : "transparent" }} />
    ))}
  </span>
);

const avg = (r) => ((r.food_rating + r.service_rating + r.recommend_rating) / 3).toFixed(1);

const fmtDate = (iso) => {
  try { return new Date(iso).toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }); }
  catch { return iso; }
};

const ReviewsPage = () => {
  const [reviews, setReviews] = useState(null);

  useEffect(() => {
    api.get("/reviews").then((r) => setReviews(r.data)).catch(() => setReviews([]));
  }, []);

  if (reviews === null) return <p className="text-muted-foreground flex items-center gap-2"><Loader2 className="w-4 h-4 animate-spin" /> Caricamento…</p>;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-cabinet font-bold text-3xl tracking-tight">Recensioni</h1>
        <p className="text-muted-foreground text-sm mt-1">Feedback lasciati dai clienti dal menù pubblico. Ricevi anche una copia via email.</p>
      </div>

      {reviews.length === 0 ? (
        <div className="bg-white rounded-2xl border border-border p-10 text-center" data-testid="reviews-empty">
          <MessageSquare className="w-10 h-10 mx-auto text-muted-foreground/40 mb-3" />
          <p className="text-muted-foreground">Ancora nessuna recensione. Quando un cliente ne lascia una, comparirà qui.</p>
        </div>
      ) : (
        <div className="space-y-4" data-testid="reviews-list">
          {reviews.map((r) => (
            <div key={r.id} data-testid={`review-${r.id}`} className="bg-white rounded-2xl border border-border p-5">
              <div className="flex items-start justify-between gap-3 flex-wrap">
                <div className="flex items-center gap-2">
                  <span className="text-2xl font-bold text-[#002FA7]">{avg(r)}</span>
                  <span className="text-xs text-muted-foreground">media / 5</span>
                </div>
                <span className="text-xs text-muted-foreground">{fmtDate(r.created_at)}</span>
              </div>
              <div className="grid sm:grid-cols-3 gap-3 mt-4">
                <div><p className="text-xs text-muted-foreground mb-1">Piatti</p><Stars n={r.food_rating} /></div>
                <div><p className="text-xs text-muted-foreground mb-1">Servizio</p><Stars n={r.service_rating} /></div>
                <div><p className="text-xs text-muted-foreground mb-1">Consiglierebbe</p><Stars n={r.recommend_rating} /></div>
              </div>
              {r.comment && <p className="text-sm mt-4 bg-muted/40 rounded-xl px-4 py-3 leading-relaxed">"{r.comment}"</p>}
              <a href={`mailto:${r.email}`} className="inline-flex items-center gap-1.5 text-sm text-[#002FA7] font-medium mt-4 hover:underline">
                <Mail className="w-4 h-4" /> {r.email}
              </a>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ReviewsPage;
